<template>
  <ul class="breadcrumbs">
    <li class="breadcrumbs__item" v-for="(item, index) in items" :key="index">
      <a v-if="!item.disabled" :href="item.key + (item.query || '')">{{ item.title }}</a>
      <a v-else @click.prevent href="/public">{{ item.title }}</a>
    </li>
  </ul>
</template>
<script>
export default {
  name: 'VlBreadcrumbs',
  props: {
    items: {
      type: Array,
      default: null,
    },
  },
}
</script>
